import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { motion } from 'framer-motion';
import { Button, LinkButton } from '../../../..';
import type { FooterProps } from '../../drawer.types';
const FOOTER_ANIMATION = {
  initial: {
    opacity: 0,
    y: 100
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.1,
      delay: 0.1
    }
  },
  exit: {
    opacity: 0,
    y: 100,
    transition: {
      duration: 0.2,
      delay: 0.1
    }
  }
} as const;
const DrawerFooter = t0 => {
  const $ = _c(17);
  const {
    primaryButton,
    secondaryButton,
    linkButton,
    isNested
  } = t0;
  const hasOnlyTwoButtons = Boolean(primaryButton && secondaryButton && !linkButton);
  const footerKey = isNested ? "nestedFooter" : "mainFooter";
  let t1;
  if ($[0] !== linkButton) {
    t1 = linkButton && <div className="flex pl-2"><LinkButton onClick={linkButton.onClick} aria-label={linkButton.label}>{linkButton.label}</LinkButton></div>;
    $[0] = linkButton;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !hasOnlyTwoButtons;
  let t3;
  if ($[2] !== hasOnlyTwoButtons || $[3] !== t2) {
    t3 = cx("flex flex-row gap-3 ml-auto", {
      "justify-between w-full": hasOnlyTwoButtons,
      "justify-end": t2
    });
    $[2] = hasOnlyTwoButtons;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== secondaryButton) {
    t4 = secondaryButton && <Button form={secondaryButton.form} loading={secondaryButton.loading} onClick={secondaryButton.onClick} disabled={secondaryButton.disabled} type={secondaryButton.type} variant="secondary" aria-label={secondaryButton.label}>{secondaryButton.label}</Button>;
    $[5] = secondaryButton;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== primaryButton) {
    t5 = primaryButton && <Button form={primaryButton.form} loading={primaryButton.loading} onClick={primaryButton.onClick} disabled={primaryButton.disabled} type={primaryButton.type} variant="primary" aria-label={primaryButton.label}>{primaryButton.label}</Button>;
    $[7] = primaryButton;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== footerKey || $[14] !== t1 || $[15] !== t6) {
    t7 = <motion.footer {...FOOTER_ANIMATION} key={footerKey} aria-label="Drawer actions" className="flex items-center justify-between w-full h-[56px] flex-shrink-0 border-t border-tertiary px-3 py-4 z-[100] box-border">{t1}{t6}</motion.footer>;
    $[13] = footerKey;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default DrawerFooter;